<template>
  <div>
    <ControlPanel :icon="'mdi mdi-comment'" :title="'Отзывы о сервисе расчета зарплаты'" :links="links">

        <b-button v-if="user.registered" v-b-modal.modal-reviews-1 size="sm" variant="primary"><span class="mdi mdi-comment"></span> Оставить отзыв о сервисе расчета зарплаты</b-button>

    </ControlPanel>
    <div class="container">
      <b-modal visible header-bg-variant="primary" header-text-variant="white" size="lg" scrollable id="modal-reviews-1" centered ok-disabled
               title="Оставить отзыв о сервисе" cancel-title-html="Закрыть" button-size="sm">
        <div>
          <p class="text-justify">Вы уже немного поработали с калькулятором расчета заработной платы и у вас сформировалось мнение о работе сервиса. Пожалуйста, оставьте свой отзыв. Ваше мнение очень важно для нас и мы прислушаемся к каждому вашему совету или предложению.</p>


          <b-form-group label="Оцените сервис по шкале от 1 до 5">
            <b-form-rating variant="primary" size="sm" show-value v-model="review.rating"></b-form-rating>
          </b-form-group>

          <b-form-group>
            <b-form-textarea
                id="textarea"
                v-model="review.text"
                placeholder="Введите текст отзыва здесь..."
                rows="5"
            ></b-form-textarea>
          </b-form-group>

        </div>

        <template v-slot:modal-footer="{cancel}">
          <b-button variant="primary" size="sm" @click="sendReview('yes')"><span class="mdi mdi-comment"></span> Оставить отзыв</b-button>
          <b-button variant="default" size="sm" @click="sendReview('no')"><span class="mdi mdi-comment-off"></span> Я не хочу оставлять отзыв</b-button>
          <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
          </b-button>
        </template>
      </b-modal>

      <transition name="fade">
        <article>
          <b-card class="mt-4 p-3">

            <p>Оставить отзыв могут только зарегистрированные пользователи.</p>




            <div class="card-text">
              <template v-for="(item, index) in reviews">
                <div  itemprop="review" itemscope itemtype="https://schema.org/Review" class="card mb-4 shadow-sm" :key="index">
                  <div class="card-header bg-primary">
                    <meta itemprop="name" :content="'Отзыв от пользователя ' + review.name">
                    <meta itemprop="reviewRating" :content="review.rating">
                    <meta itemprop="datePublished" :content="review.dateraw">
                    <b-form-rating variant="white" class="bg-transparent p-0" id="rating-inline" size="sm" readonly no-border inline :value="item.rating"></b-form-rating>
                  </div>
                  <div class="card-body p-4 bg-light">
                    <div class="row">
                      <div class="col-3 text-center">
                        <b-avatar></b-avatar>
                        <br>
                        <small><span itemprop="author">{{item.name}}</span>, {{item.phone}}</small><br>
                        <small>Клиент сервиса с {{item.regdate}}</small>
                      </div>
                      <div class="col-9">
                        <div itemprop="reviewBody" v-html="item.text"></div>


                        <div class="card bg-white mt-4" v-if="typeof item.answer !== 'undefined'">
                          <div class="card-body">
                            <h5>Ответ разработчика:</h5>
                            <small class="text-muted">{{item.answer.date}}</small>
                            <div v-html="item.answer.text"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <small class="text-muted">{{item.date}}</small>
                  </div>

                </div>
              </template>
            </div>
          </b-card>
        </article>
      </transition>
    </div>
  </div>

</template>


<script>
import {mapGetters} from "vuex";
import ControlPanel from "@/components/base/ControlPanel";
export default {
  name: 'Reviews',
  components: {
    ControlPanel
  },
  data: function () {
    return {
      reviews: [],
      review: {
        rating: 0,
        text: ''
      }
    }
  },
  methods: {
    sendReview: function (mode) {
      this.$store.commit('wait', {state: true, name: 'Отправка отзыва разработчику'});
      this.$http
          .post(this.$apiold, {
            task: 'send-review',
            review: this.review,
            mode: mode
          })
          .then(response => {
            this.$store.commit('wait', {state: false});

            // Сообщения
            this.$store.commit('alert', response.data.messages);

            if (!response.data.error) {
              this.$bvModal.hide('modal-reviews-1');
            }
          });

    },
    getReviews: function () {
      this.$store.state.wait = {state: true, name: 'Загрузка списка отзывов'};
      this.$http
          .post(this.$apiold, {
            task: 'reviews',
            id: this.id
          })
          .then(response => {
            this.$store.state.wait = {state: false};
            this.reviews = response.data.result.reviews;

            //this.$store.commit('setRating', this.reviews);
          });
    }

  },

  created() {
    this.getReviews();
  },
  computed: {
    ...mapGetters({
      user: 'user',
      links: 'links'
    })
  }
}
</script>
